// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   FORGE — master.css
   Global design controller. Every color, font, size, and spacing
   value used across the site is defined here as a token.
   Change a value here and it cascades everywhere.
   ============================================================ */

/* ---- Type loading -----------------------------------------
   Display : Anton          -> heavy condensed poster headlines
                               (stand-in for PP Neue Machina Inktrap)
   Serif   : Playfair Display-> wordmark, nav, editorial accents
                               (stand-in for Editorial New)
   Body    : Inter          -> body copy, UI, buttons (exact match)
   Swap any of these by editing --font-* below + this import.
   ------------------------------------------------------------ */

:root {
  /* ---- Brand palette (from the Forge mood board) ---- */
  --c-cream: #f4efe6; /* base background            */
  --c-sand: #dcccb4; /* secondary surface / borders (set to client's exact swatch) */
  --c-rust: #a86642; /* primary accent / CTAs      */
  --c-sage: #5f7158; /* secondary accent           */
  --c-forest: #384638; /* deep green headings         */
  --c-ink: #1b1b1b; /* near-black text             */

  /* ---- Semantic roles (use these in components) ---- */
  --bg: var(--c-cream);
  --surface: #ece4d6;
  --text: var(--c-ink);
  --text-muted: #5b554c;
  --accent: var(--c-rust);
  --accent-hover: #93542f;
  --on-accent: #f6efe6;
  --line: rgba(27, 27, 27, 0.18);

  /* ---- Typefaces ---- */
  --font-display: "Anton", "Arial Narrow", sans-serif;
  --font-serif: "Playfair Display", Georgia, serif;
  --font-body: "Inter", system-ui, -apple-system, sans-serif;

  /* ---- Type scale (fluid) ---- */
  --fs-hero: clamp(3.2rem, 7vw, 8.8rem);
  --fs-display: clamp(2.2rem, 5vw, 3.75rem);
  --fs-h2: clamp(1.7rem, 3.2vw, 2.6rem);
  --fs-h3: clamp(1.15rem, 1.8vw, 1.4rem);
  --fs-lead: clamp(1.05rem, 1.4vw, 1.25rem);
  --fs-body: 1rem;
  --fs-sm: 0.875rem;
  --fs-xs: 0.75rem;

  /* ---- Tracking ---- */
  --track-tight: -0.01em;
  --track-display: -0.5px;
  --track-eyebrow: 0.22em;
  --track-nav: 0.06em;

  /* ---- Line height ---- */
  --lh-tight: 0.92;
  --lh-snug: 1.15;
  --lh-body: 1.6;

  /* ---- Spacing scale ---- */
  --sp-1: 0.25rem;
  --sp-2: 0.5rem;
  --sp-3: 0.75rem;
  --sp-4: 1rem;
  --sp-5: 1.5rem;
  --sp-6: 2rem;
  --sp-7: 3rem;
  --sp-8: 4rem;
  --sp-9: 6rem;
  --sp-10: 8rem;

  /* ---- Layout ---- */
  --container-max: 1320px;
  --gutter: clamp(1.25rem, 4vw, 3.5rem);
  --section-y: clamp(3.5rem, 8vw, 7rem);

  /* ---- Detail ---- */
  --radius-sm: 2px;
  --radius: 4px;
  --shadow: 0 18px 40px -22px rgba(27, 27, 27, 0.45);
  --ease: cubic-bezier(0.22, 1, 0.36, 1);
  --dur: 0.5s;
}

/* ---- Reset / base ---------------------------------------- */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family: var(--font-body);
  font-size: var(--fs-body);
  line-height: var(--lh-body);
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

h1,
h2,
h3,
h4 {
  margin: 0;
  line-height: var(--lh-snug);
}
p {
  margin: 0;
}
img {
  display: block;
  max-width: 100%;
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  font-family: inherit;
}

/* ---- Shared helpers -------------------------------------- */
.container-fg {
  width: 100%;
  max-width: var(--container-max);
  margin-inline: auto;
  padding-inline: var(--gutter);
}

/* condensed poster display type */
.u-display {
  font-family: var(--font-display);
  font-weight: 400;
  text-transform: uppercase;
  line-height: var(--lh-tight);
  letter-spacing: var(--track-display);
}

/* small letterspaced label / eyebrow */
.u-eyebrow {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
  color: var(--text-muted);
}

.u-serif {
  font-family: var(--font-serif);
}
.u-accent {
  color: var(--accent);
}

/* ---- Accessibility --------------------------------------- */
:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}

.container-2xxl {
  max-width: 1600px !important;
}

.rotateC {
  animation: rotate 7s linear infinite;
}

@keyframes rotate {
  0% {
    rotate: 0deg;
  }
  100% {
    rotate: 360deg;
  }
}

/* ── Circular badge ─────────────────────────────────────────── */
.wws__badge {
  position: relative;
  width: clamp(100px, 11vw, 148px);
  height: clamp(100px, 11vw, 148px);
  flex-shrink: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.wws__badge-ring {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.wws__badge-circle {
  fill: none;
  stroke: var(--accent);
  stroke-width: 1;
  opacity: 0.55;
}

.wws__badge-text {
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.18em;
  fill: var(--accent);
  text-transform: uppercase;
}

.wws__badge-tick {
  stroke: var(--accent);
  stroke-width: 1.5;
  opacity: 0.7;
}

/* Forge logo centred inside badge */

/* ── Cerro Tusa stamp ──────────────────────────────────────── */
.ite__stamp {
  grid-column: 5;
  transform: rotate(-10deg);

  padding: clamp(0.7rem, 1.2vw, 1rem) clamp(0.75rem, 1.2vw, 1.1rem);
  min-width: clamp(130px, 14vw, 180px);
  max-width: 100%;
  position: relative;
  /* Stamp clip-path — serrated all-round */
  clip-path: polygon(
    3% 0%,
    7% 2%,
    12% 0%,
    17% 2%,
    22% 0%,
    27% 2%,
    32% 0%,
    37% 2%,
    42% 0%,
    47% 2%,
    52% 0%,
    57% 2%,
    62% 0%,
    67% 2%,
    72% 0%,
    77% 2%,
    82% 0%,
    87% 2%,
    92% 0%,
    97% 2%,
    100% 4%,
    98% 9%,
    100% 14%,
    98% 19%,
    100% 24%,
    98% 29%,
    100% 34%,
    98% 39%,
    100% 44%,
    98% 49%,
    100% 54%,
    98% 59%,
    100% 64%,
    98% 69%,
    100% 74%,
    98% 79%,
    100% 84%,
    98% 89%,
    100% 94%,
    97% 98%,
    92% 100%,
    87% 98%,
    82% 100%,
    77% 98%,
    72% 100%,
    67% 98%,
    62% 100%,
    57% 98%,
    52% 100%,
    47% 98%,
    42% 100%,
    37% 98%,
    32% 100%,
    27% 98%,
    22% 100%,
    17% 98%,
    12% 100%,
    7% 98%,
    3% 100%,
    0% 96%,
    2% 91%,
    0% 86%,
    2% 81%,
    0% 76%,
    2% 71%,
    0% 66%,
    2% 61%,
    0% 56%,
    2% 51%,
    0% 46%,
    2% 41%,
    0% 36%,
    2% 31%,
    0% 26%,
    2% 21%,
    0% 16%,
    2% 11%,
    0% 6%
  );
}

.ite__stamp-inner {
  border: 1.5px solid var(--c-ink);
  padding: 0.55rem 0.65rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.ite__stamp-top {
  display: flex;
  flex-direction: column;
}

.ite__stamp-place {
  font-family: var(--font-display);
  font-size: clamp(0.85rem, 1.3vw, 1.1rem);
  color: var(--c-ink);
  letter-spacing: 0.06em;
  line-height: 1;
}

.ite__stamp-country {
  font-family: var(--font-body);
  font-size: 0.58rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.ite__stamp-mtn {
  width: 100%;
  height: auto;
  margin: 0.2rem 0;
}

.mountainesIco {
  width: 60%;
  margin-left: auto;
  position: absolute;
  bottom: 5%;
  right: 5%;
  transform: translateY(-10%);
}

.ite__stamp-mtn-peak {
  fill: var(--c-forest);
  opacity: 0.7;
}

.ite__stamp-mtn-peak.front {
  fill: var(--c-ink);
  opacity: 0.85;
}

.ite__stamp-mtn-snow {
  fill: var(--c-cream);
}

.ite__stamp-coords {
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 600;
  color: var(--c-ink);
  line-height: 1.5;
  letter-spacing: 0.04em;
}
`, "",{"version":3,"sources":["webpack://./src/components/master.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;;;;;;;iEAOiE;;AAGjE;EACE,wDAAwD;EACxD,kBAAkB,EAAE,+BAA+B;EACnD,iBAAiB,EAAE,+DAA+D;EAClF,iBAAiB,EAAE,+BAA+B;EAClD,iBAAiB,EAAE,+BAA+B;EAClD,mBAAmB,EAAE,gCAAgC;EACrD,gBAAgB,EAAE,gCAAgC;;EAElD,uDAAuD;EACvD,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;;EAE9B,wBAAwB;EACxB,mDAAmD;EACnD,gDAAgD;EAChD,0DAA0D;;EAE1D,iCAAiC;EACjC,qCAAqC;EACrC,yCAAyC;EACzC,qCAAqC;EACrC,sCAAsC;EACtC,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;EAEhB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;;EAEnB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,cAAc;;EAEd,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;;EAEb,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;EACrC,qCAAqC;;EAErC,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,kDAAkD;EAClD,sCAAsC;EACtC,WAAW;AACb;;AAEA,+DAA+D;AAC/D;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;EAIE,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;;AAEA,+DAA+D;AAC/D;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE;IACE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;IACvC,gCAAgC;EAClC;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;EACjC,cAAc;;EAEd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;AACd;;AAEA,oCAAoC;;AAEpC,iEAAiE;AACjE;EACE,cAAc;EACd,yBAAyB;;EAEzB,iEAAiE;EACjE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+EC;AACH;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["/* ============================================================\n   FORGE — master.css\n   Global design controller. Every color, font, size, and spacing\n   value used across the site is defined here as a token.\n   Change a value here and it cascades everywhere.\n   ============================================================ */\n\n/* ---- Type loading -----------------------------------------\n   Display : Anton          -> heavy condensed poster headlines\n                               (stand-in for PP Neue Machina Inktrap)\n   Serif   : Playfair Display-> wordmark, nav, editorial accents\n                               (stand-in for Editorial New)\n   Body    : Inter          -> body copy, UI, buttons (exact match)\n   Swap any of these by editing --font-* below + this import.\n   ------------------------------------------------------------ */\n@import url(\"https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&display=swap\");\n\n:root {\n  /* ---- Brand palette (from the Forge mood board) ---- */\n  --c-cream: #f4efe6; /* base background            */\n  --c-sand: #dcccb4; /* secondary surface / borders (set to client's exact swatch) */\n  --c-rust: #a86642; /* primary accent / CTAs      */\n  --c-sage: #5f7158; /* secondary accent           */\n  --c-forest: #384638; /* deep green headings         */\n  --c-ink: #1b1b1b; /* near-black text             */\n\n  /* ---- Semantic roles (use these in components) ---- */\n  --bg: var(--c-cream);\n  --surface: #ece4d6;\n  --text: var(--c-ink);\n  --text-muted: #5b554c;\n  --accent: var(--c-rust);\n  --accent-hover: #93542f;\n  --on-accent: #f6efe6;\n  --line: rgba(27, 27, 27, 0.18);\n\n  /* ---- Typefaces ---- */\n  --font-display: \"Anton\", \"Arial Narrow\", sans-serif;\n  --font-serif: \"Playfair Display\", Georgia, serif;\n  --font-body: \"Inter\", system-ui, -apple-system, sans-serif;\n\n  /* ---- Type scale (fluid) ---- */\n  --fs-hero: clamp(3.2rem, 7vw, 8.8rem);\n  --fs-display: clamp(2.2rem, 5vw, 3.75rem);\n  --fs-h2: clamp(1.7rem, 3.2vw, 2.6rem);\n  --fs-h3: clamp(1.15rem, 1.8vw, 1.4rem);\n  --fs-lead: clamp(1.05rem, 1.4vw, 1.25rem);\n  --fs-body: 1rem;\n  --fs-sm: 0.875rem;\n  --fs-xs: 0.75rem;\n\n  /* ---- Tracking ---- */\n  --track-tight: -0.01em;\n  --track-display: -0.5px;\n  --track-eyebrow: 0.22em;\n  --track-nav: 0.06em;\n\n  /* ---- Line height ---- */\n  --lh-tight: 0.92;\n  --lh-snug: 1.15;\n  --lh-body: 1.6;\n\n  /* ---- Spacing scale ---- */\n  --sp-1: 0.25rem;\n  --sp-2: 0.5rem;\n  --sp-3: 0.75rem;\n  --sp-4: 1rem;\n  --sp-5: 1.5rem;\n  --sp-6: 2rem;\n  --sp-7: 3rem;\n  --sp-8: 4rem;\n  --sp-9: 6rem;\n  --sp-10: 8rem;\n\n  /* ---- Layout ---- */\n  --container-max: 1320px;\n  --gutter: clamp(1.25rem, 4vw, 3.5rem);\n  --section-y: clamp(3.5rem, 8vw, 7rem);\n\n  /* ---- Detail ---- */\n  --radius-sm: 2px;\n  --radius: 4px;\n  --shadow: 0 18px 40px -22px rgba(27, 27, 27, 0.45);\n  --ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --dur: 0.5s;\n}\n\n/* ---- Reset / base ---------------------------------------- */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  background: var(--bg);\n  color: var(--text);\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  line-height: var(--lh-body);\n  font-weight: 400;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  margin: 0;\n  line-height: var(--lh-snug);\n}\np {\n  margin: 0;\n}\nimg {\n  display: block;\n  max-width: 100%;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nbutton {\n  font-family: inherit;\n}\n\n/* ---- Shared helpers -------------------------------------- */\n.container-fg {\n  width: 100%;\n  max-width: var(--container-max);\n  margin-inline: auto;\n  padding-inline: var(--gutter);\n}\n\n/* condensed poster display type */\n.u-display {\n  font-family: var(--font-display);\n  font-weight: 400;\n  text-transform: uppercase;\n  line-height: var(--lh-tight);\n  letter-spacing: var(--track-display);\n}\n\n/* small letterspaced label / eyebrow */\n.u-eyebrow {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.u-serif {\n  font-family: var(--font-serif);\n}\n.u-accent {\n  color: var(--accent);\n}\n\n/* ---- Accessibility --------------------------------------- */\n:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 3px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n.container-2xxl {\n  max-width: 1600px !important;\n}\n\n.rotateC {\n  animation: rotate 7s linear infinite;\n}\n\n@keyframes rotate {\n  0% {\n    rotate: 0deg;\n  }\n  100% {\n    rotate: 360deg;\n  }\n}\n\n/* ── Circular badge ─────────────────────────────────────────── */\n.wws__badge {\n  position: relative;\n  width: clamp(100px, 11vw, 148px);\n  height: clamp(100px, 11vw, 148px);\n  flex-shrink: 0;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wws__badge-ring {\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n\n.wws__badge-circle {\n  fill: none;\n  stroke: var(--accent);\n  stroke-width: 1;\n  opacity: 0.55;\n}\n\n.wws__badge-text {\n  font-family: var(--font-body);\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.18em;\n  fill: var(--accent);\n  text-transform: uppercase;\n}\n\n.wws__badge-tick {\n  stroke: var(--accent);\n  stroke-width: 1.5;\n  opacity: 0.7;\n}\n\n/* Forge logo centred inside badge */\n\n/* ── Cerro Tusa stamp ──────────────────────────────────────── */\n.ite__stamp {\n  grid-column: 5;\n  transform: rotate(-10deg);\n\n  padding: clamp(0.7rem, 1.2vw, 1rem) clamp(0.75rem, 1.2vw, 1.1rem);\n  min-width: clamp(130px, 14vw, 180px);\n  max-width: 100%;\n  position: relative;\n  /* Stamp clip-path — serrated all-round */\n  clip-path: polygon(\n    3% 0%,\n    7% 2%,\n    12% 0%,\n    17% 2%,\n    22% 0%,\n    27% 2%,\n    32% 0%,\n    37% 2%,\n    42% 0%,\n    47% 2%,\n    52% 0%,\n    57% 2%,\n    62% 0%,\n    67% 2%,\n    72% 0%,\n    77% 2%,\n    82% 0%,\n    87% 2%,\n    92% 0%,\n    97% 2%,\n    100% 4%,\n    98% 9%,\n    100% 14%,\n    98% 19%,\n    100% 24%,\n    98% 29%,\n    100% 34%,\n    98% 39%,\n    100% 44%,\n    98% 49%,\n    100% 54%,\n    98% 59%,\n    100% 64%,\n    98% 69%,\n    100% 74%,\n    98% 79%,\n    100% 84%,\n    98% 89%,\n    100% 94%,\n    97% 98%,\n    92% 100%,\n    87% 98%,\n    82% 100%,\n    77% 98%,\n    72% 100%,\n    67% 98%,\n    62% 100%,\n    57% 98%,\n    52% 100%,\n    47% 98%,\n    42% 100%,\n    37% 98%,\n    32% 100%,\n    27% 98%,\n    22% 100%,\n    17% 98%,\n    12% 100%,\n    7% 98%,\n    3% 100%,\n    0% 96%,\n    2% 91%,\n    0% 86%,\n    2% 81%,\n    0% 76%,\n    2% 71%,\n    0% 66%,\n    2% 61%,\n    0% 56%,\n    2% 51%,\n    0% 46%,\n    2% 41%,\n    0% 36%,\n    2% 31%,\n    0% 26%,\n    2% 21%,\n    0% 16%,\n    2% 11%,\n    0% 6%\n  );\n}\n\n.ite__stamp-inner {\n  border: 1.5px solid var(--c-ink);\n  padding: 0.55rem 0.65rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.ite__stamp-top {\n  display: flex;\n  flex-direction: column;\n}\n\n.ite__stamp-place {\n  font-family: var(--font-display);\n  font-size: clamp(0.85rem, 1.3vw, 1.1rem);\n  color: var(--c-ink);\n  letter-spacing: 0.06em;\n  line-height: 1;\n}\n\n.ite__stamp-country {\n  font-family: var(--font-body);\n  font-size: 0.58rem;\n  font-weight: 600;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.ite__stamp-mtn {\n  width: 100%;\n  height: auto;\n  margin: 0.2rem 0;\n}\n\n.mountainesIco {\n  width: 60%;\n  margin-left: auto;\n  position: absolute;\n  bottom: 5%;\n  right: 5%;\n  transform: translateY(-10%);\n}\n\n.ite__stamp-mtn-peak {\n  fill: var(--c-forest);\n  opacity: 0.7;\n}\n\n.ite__stamp-mtn-peak.front {\n  fill: var(--c-ink);\n  opacity: 0.85;\n}\n\n.ite__stamp-mtn-snow {\n  fill: var(--c-cream);\n}\n\n.ite__stamp-coords {\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: var(--c-ink);\n  line-height: 1.5;\n  letter-spacing: 0.04em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
